function checkRunTimeEnvironment(key: string) {
  const { public: { env } } = useRuntimeConfig()
  return env === key
}

/** 判断是否处于开发环境（可以是代理了正服、测服环境，区分正测服环境则看下面isTest、isPreRelease、isProd） */
export function isLocal() {
  const { public: { runtimeEnv } } = useRuntimeConfig()
  return runtimeEnv === 'local'
}

/** 判断是否测试环境 */
export function isTest() {
  return checkRunTimeEnvironment('test')
}

/** 判断是否正式环境 */
export function isProd() {
  return checkRunTimeEnvironment('production')
}

/** 判断是预发布环境 */
export function isPreRelease() {
  return checkRunTimeEnvironment('pre-release')
}

/** 判断是投放版本 */
export function isProductionAd() {
  return checkRunTimeEnvironment('production_ad')
}

/** 判断是日本定制版本 */
export function isProductionJp() {
  return checkRunTimeEnvironment('production_jp')
}

/** 盛天定制 */
export function isProductionTideGame() {
  return checkRunTimeEnvironment('production_tide_game')
}
